require('./assets/javascripts/angular-bootstrap/ui-bootstrap.min.js');
require('./assets/javascripts/angular-bootstrap/ui-bootstrap-tpls.min.js');
require('./assets/javascripts/angular-form-builder-custom/angular-form-builder.js');
require('./assets/javascripts/angular-form-builder-custom/angular-form-builder-components.js');
require('./assets/javascripts/angular-logex/dist/log-ex-unobtrusive.min.js');